// Amount Limit for Invoice Payment
export const LIMIT = 50000;

export const HEADER_COLUMNS = [
  { label: 'Invoice #', id: 'invoice' },
  { label: 'Location', id: 'location' },
  { label: 'Certificate', id: 'certificate' },
  { label: 'Coverage', id: 'coverage' },
  { label: 'Effective Date', id: 'date' },
  { label: 'Premium', id: 'premium' },
];

export const RECOVERY_QUESTIONS = [
  `Who's a major player in the cowboy scene?`,
  'What was the first concert you attended?',
  'What was the name of your first stuffed animal?',
  'What is the middle name of your oldest sibling?',
  'What was the name of your first teacher?',
  'What is the make and model of your first car?',
  'What is the name of the city where your parents met?',
  'What is the title of your favorite childhood book?',
];
